import {TOKENS} from '../../tokens'

export const dialog = {
  dark: {
    border: TOKENS.dark.contrast_200,
    shadow: TOKENS.dark.black,
    backdrop: TOKENS.dark.black,
  },
  light: {
    border: TOKENS.light.contrast_200,
    shadow: TOKENS.light.black,
    backdrop: TOKENS.light.black,
  },
} as const
